export const FOLDER_ID_PARAM = 'fid';
export const TENANCY_ID_PARAM = 'tid';
